import { render, staticRenderFns } from "./make-deposit.component.vue?vue&type=template&id=ff950d4a&"
import script from "./make-deposit.component.vue?vue&type=script&lang=ts&"
export * from "./make-deposit.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports